"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const constants_1 = __importStar(require("../utils/constants"));
const _base_1 = require("./_base");
/**
 * ![NoIcon](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDkuNDcgOS40NyI+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5jbHMtMSB7CiAgICAgICAgZmlsbDogI2ZmZjsKICAgICAgfQogICAgPC9zdHlsZT4KICA8L2RlZnM+CiAgPHRpdGxlPk5vPC90aXRsZT4KICA8ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIj4KICAgIDxnIGlkPSJMYXllcl8xLTIiIGRhdGEtbmFtZT0iTGF5ZXIgMSI+CiAgICAgIDxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTUuNDQsNC43NCw5LjMzLjg1YS41LjUsMCwwLDAsMC0uNy41LjUsMCwwLDAtLjcxLDBMNC43NCw0LC44NS4xNWEuNDguNDgsMCwwLDAtLjcsMCwuNDguNDgsMCwwLDAsMCwuN0w0LDQuNzQuMTUsOC42MmEuNS41LDAsMCwwLC4zNS44NS41LjUsMCwwLDAsLjM1LS4xNEw0Ljc0LDUuNDQsOC42Miw5LjMzQS41Mi41MiwwLDAsMCw5LDkuNDdhLjU0LjU0LDAsMCwwLC4zNi0uMTQuNTEuNTEsMCwwLDAsMC0uNzFaIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K)
 */
exports.NoIcon = (_a) => {
    var { size = 18, color } = _a, props = __rest(_a, ["size", "color"]);
    const iconColor = constants_1.expandColor(constants_1.default, color) || "currentColor";
    return (React.createElement(_base_1.Svg, Object.assign({ viewBox: "0 0 9.47 9.47", fill: iconColor, width: size, height: size, size: size, role: props.onClick ? "button" : undefined, tabIndex: props.onClick ? 0 : undefined }, props),
        React.createElement("path", { d: "M5.44 4.74L9.33.85a.5.5 0 0 0 0-.7.5.5 0 0 0-.71 0L4.74 4 .85.15a.48.48 0 0 0-.7 0 .48.48 0 0 0 0 .7L4 4.74.15 8.62a.5.5 0 0 0 .35.85.5.5 0 0 0 .35-.14l3.89-3.89 3.88 3.89a.52.52 0 0 0 .38.14.54.54 0 0 0 .36-.14.51.51 0 0 0 0-.71z" })));
};
//# sourceMappingURL=Icon.No.js.map